import Image from 'next/image'
import { Maybe } from 'src/types/graphql'
import emptyImg from '../../../public/images/avatar.png'
import { Monogram } from './Monogram'

export const Avatar = ({
  src,
  className,
  alt,
  sizes,
  fallbackName,
  fallbackTextClassName
}: {
  src?: Maybe<string> | undefined
  className?: string
  alt?: string
  sizes?: string
  /**
   * Draw a deterministic initials tile instead of the grey silhouette when
   * there is no `src`. Pass the TEAM or person name on surfaces where the
   * identity is already known to the viewer — a host profile, the dashboard,
   * the checkout parties block, a chat with someone you have booked with.
   *
   * 🛑 Do NOT pass it where the party is deliberately anonymous (renter-facing
   * listings, pre-booking chat). Initials are a much shorter guess than a
   * blank circle — see `Monogram`.
   */
  fallbackName?: Maybe<string>
  /** Type scale for the fallback initials; size it against `className`. */
  fallbackTextClassName?: string
}) => {
  if (!src && fallbackName) {
    return (
      <Monogram
        name={fallbackName}
        className={className ?? 'size-10'}
        textClassName={fallbackTextClassName}
      />
    )
  }

  const imgSrc = src ?? emptyImg

  return (
    <div
      className={`relative rounded-full ${className ? className : 'size-10'}`}
    >
      <Image
        className="rounded-full object-cover "
        src={imgSrc}
        alt={alt ? alt : ''}
        fill
        sizes={sizes}
      />
    </div>
  )
}
